<div class="w-full flex flex-col gap-y-2">
    <div class="flex flex-row items-center gap-x-4 w-full pt-2">
        <h2 class="text-sm font-semibold text-primary flex-nowrap min-w-fit">Ad Basics</h2>
        <div class="border-b border-gray-200 dark:border-gray-800 w-full"></div>
        <button (click)="expanded.set(!expanded())" type="button" class="fab-button-secondary-small text-secondary">
            @if (expanded()) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m18 15-6-6-6 6" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="size-5">
                <path d="m6 9 6 6 6-6" />
            </svg>
            }
        </button>
    </div>


    @if (expanded()) {
    <article class="briefing-section-card relative isolate flex flex-col gap-8 lg:flex-row">
        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div class="sm:col-span-4">
                <label for="ad-group-name-input" class="block text-sm/6 font-medium text-primary">
                    Ad Name
                    <p class="text-xs text-secondary">Give your Spark Ad a name that will help you identify it.</p>
                </label>
                <div class="mt-2 relative flex items-center w-full shadow-xs rounded-md">
                    <input type="text" id="ad-group-name-input"
                        class="border-x-0 input-primary text-left text-primary h-10 w-full px-3"
                        placeholder="e.g. Spring creators — US"
                        [formControl]="adNameControl" />
                </div>
            </div>
        </div>

    </article>
    }
</div>